import React from 'react';
import { IHotel } from 'services/BackendApi';
import * as Inputs from '../Inputs';
import FluidButton from 'ui/FluidButton';
import { validateOverview } from 'containers/HotelAdmin/validation';
import { enqueueNotification } from 'store/modules/ui';
import { useDispatch } from 'react-redux';

export const OverviewTab = ({
  hotel,
  onUpdate,
  onPatchHotel,
}: {
  hotel: IHotel;
  onUpdate: (field: keyof IHotel, value: any) => void;
  onPatchHotel: (updatedData: Partial<IHotel>) => void;
}) => {
  const dispatch = useDispatch();
  return (
    <div className="flex flex-col space-y-4 w-full">
      <Inputs.CrudList
        collection={hotel.overview || []}
        className="w-full"
        onChange={newList => {
          onUpdate('overview', newList);
        }}
      />
      <hr />
      <FluidButton
        type="primary"
        className="self-end w-[300px] mt-4"
        onClick={() => {
          const validation = validateOverview(hotel as IHotel);
          if (validation.isValid === false) {
            dispatch(
              enqueueNotification({
                message: `Overview is not valid: ${validation.message}`,
                options: { variant: 'warning' },
              })
            );
            return;
          }
          onPatchHotel({
            overview: hotel.overview,
          });
        }}
      >
        Update Overview
      </FluidButton>
    </div>
  );
};
